var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81999 8.46335C2.01529 8.26813 2.33187 8.2682 2.5271 8.4635L7.50022 13.4387V0.619629C7.50022 0.343487 7.72407 0.119629 8.00022 0.119629C8.27636 0.119629 8.50022 0.343487 8.50022 0.619629V13.439L13.4758 8.46343C13.6711 8.26816 13.9876 8.26816 14.1829 8.46343C14.3782 8.65869 14.3782 8.97527 14.1829 9.17053L8.00014 15.3533L1.81984 9.17046C1.62462 8.97516 1.62469 8.65858 1.81999 8.46335Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.669922 18.3805C0.669922 18.1044 0.893779 17.8805 1.16992 17.8805H14.8322C15.1083 17.8805 15.3322 18.1044 15.3322 18.3805C15.3322 18.6567 15.1083 18.8805 14.8322 18.8805H1.16992C0.893779 18.8805 0.669922 18.6567 0.669922 18.3805Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.648a558bfcd5c4b6efdf53211394bb81.svg";
export { ForwardRef as ReactComponent };